/**
 * VariancePage — Forecast vs. Actuals comparison.
 * Shows week-by-week variance with color-coded delta cells.
 */

import React from 'react';
import { Card, CardContent } from '../../components/ui';

export default function VariancePage() {
  return (
    <div className="space-y-6 mt-2">
      <Card>
        <CardContent className="p-8 text-center">
          <h2 className="text-lg font-semibold text-charcoal dark:text-gray-100 mb-2">
            Forecast vs. Actuals
          </h2>
          <p className="text-gray-500 dark:text-gray-400 mb-4">
            Variance analysis will be available once actual cash position data has been loaded
            for at least one completed forecast period.
          </p>
          <p className="text-xs text-gray-400">
            Upload actuals via the Admin &gt; Data Uploads tab to enable this view.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
